/** Match `sortable-playlist-media-list` drag handle width. */
export const SLOT_LIST_DRAG_HANDLE_SIZE_PX = 22;

/** Time stack only; leading column holds drag/lock/spacer (22px) when schedule uses `showSlotDragHandle`. */
export const SLOT_LIST_LEFT_COLUMN_MIN_WIDTH_PX = 60;
export const SLOT_LIST_RIGHT_COLUMN_WIDTH_PX = 65;

export type SlotListColumnLayout = {
  leftMinWidthPx: number;
  rightWidthPx: number;
  leadingGutterPx: number;
};

export function getSlotListColumnWidths(showDragHandleColumn: boolean) {
  const dragExtra = showDragHandleColumn ? SLOT_LIST_DRAG_HANDLE_SIZE_PX : 0;
  return {
    leftMinWidthPx: SLOT_LIST_LEFT_COLUMN_MIN_WIDTH_PX + dragExtra,
    rightWidthPx: SLOT_LIST_RIGHT_COLUMN_WIDTH_PX - dragExtra,
  };
}

export function getSlotListColumnLayout(showDragHandleColumn: boolean): SlotListColumnLayout {
  const { leftMinWidthPx, rightWidthPx } = getSlotListColumnWidths(showDragHandleColumn);
  return {
    leftMinWidthPx,
    rightWidthPx,
    leadingGutterPx: showDragHandleColumn ? SLOT_LIST_DRAG_HANDLE_SIZE_PX : 0,
  };
}
